export default "__VITE_ASSET__DzcauDw5__"